import api from '@pray/shared/utils/api';

import { ENTITY_TYPES } from './constants';

export const getContentComments = async ({ artistId, entityId, entityType, cursor } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!entityId) throw Error('Entity ID is required');
  if (!entityType) throw Error('Entity type is required');

  const entityPath = entityType === ENTITY_TYPES.DAILY ? 'daily-items' : 'content';
  const url = `/web/studio/artists/${artistId}/${entityPath}/${entityId}/comments/page`;

  const params = {};
  if (cursor) params.oldest = cursor;

  const response = await api.executeGetRequest(url, params);
  return response.data;
};
